import {FC, ReactNode} from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {getLocalStorage} from '../../shared/utils/localstorage.util.ts';
import {ACCESS_TOKEN_LS_KEY} from '../../shared/utils/api-request.helper.ts';

const RoutesProtection: FC<{ children: ReactNode }> = ({children}) => {
    const token = getLocalStorage(ACCESS_TOKEN_LS_KEY);
    const location = useLocation();

    // Если пользователь НЕ авторизован → отправляем на /login
    if (!token) {
        return <Navigate to='/login' replace/>;
    }

    // Если пользователь авторизован и заходит на /login → перенаправляем на /main
    if (location.pathname === '/login') {
        return <Navigate to='/main' replace/>;
    }

    return <>{children}</>;
};

export default RoutesProtection;